export const endpointName = "meterRead";